// extracted by mini-css-extract-plugin
export default {"ComingSoonComponent":"ComingSoonComponent_ComingSoonComponent__zZOVt","iconWrap":"ComingSoonComponent_iconWrap__+MvUD"};